import { Product } from '@/types';
import { getParams } from '@/utils/params';
import { fetchFromApiSignedIfAdmin } from './fetchFromApi';

export const fetchProduct = (productId: string) =>
  fetchFromApiSignedIfAdmin<Product>(
    `${getParams().context}s/${getParams().contextId}/products/${productId}`,
    {
      mode: 'designer',
    }
  );
